import { useQuery } from '@apollo/client';
import React from 'react';
import { SortDirection, generatedTypesNew, Maybe, PaymentMethod } from '@css-xp/graphtypes';
import { fetchInvoicesForShipToParty } from './queries/fetch-invoices-for-ship-to-party';
import { DEFAULT_ROWS_PER_PAGE } from '@atlassian/cssxp-utils-entitlement';
import InvoiceTabIg from '../../../invoice-group/src/invoice-tab-ig';

interface InvoicesTableForShipToPartyProps {
  shipToPartyId: string;
  transactionAccountId?: string;
  label?: string;
  availablePaymentMethods?: Maybe<Maybe<PaymentMethod>[]> | undefined;
}

const sortOptions = {
  sortFields: ['createdDate', 'id'],
  sortFieldsDirections: [SortDirection.DESC, SortDirection.DESC],
};

export const InvoicesTableForShipToParty = ({
  shipToPartyId,
  transactionAccountId,
  label,
  availablePaymentMethods,
}: InvoicesTableForShipToPartyProps) => {
  const { refetch, loading, error, data } = useQuery<
    generatedTypesNew.FetchInvoicesForShipToPartyQuery,
    generatedTypesNew.FetchInvoicesForShipToPartyQueryVariables
  >(fetchInvoicesForShipToParty, {
    variables: {
      id: shipToPartyId,
      searchOptions: {
        first: DEFAULT_ROWS_PER_PAGE,
        sort: { ...sortOptions },
      },
    },
    nextFetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  // variables to use for paging and populating our template
  const totalCount = data?.invoiceGroupsForShipToPartyId?.invoices?.totalCount ?? 0;
  const nodes = data?.invoiceGroupsForShipToPartyId?.invoices?.nodes;

  return (
    <InvoiceTabIg
      transactionAccountId={transactionAccountId}
      nodes={nodes}
      totalRecords={totalCount}
      loading={loading}
      error={error}
      refetch={refetch}
      label={label}
      availablePaymentMethods={availablePaymentMethods}
      isShipToPartySidebar={true}
    />
  );
};
